import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { deleteAssessmentItemMutation, deleteAssessmentItemMutationVariables } from '../generated/deleteAssessmentItemMutation';
import { assessmentItemFieldsFragment } from '../models/AssessmentItem';

/**
 * Get a callback to delete a AssessmentItem in the store.
 */
export function useDeleteAssessmentItemCallback(): [(id: string) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<deleteAssessmentItemMutation, deleteAssessmentItemMutationVariables>(
        gql`
            mutation deleteAssessmentItemMutation ($id: ID!) {
                deleteAssessmentItem(id: $id) {
                    ...assessmentItemFields
                }
            }

            ${assessmentItemFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (id: string) => {
        const result = await mutationAction({ variables: { id: id } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
